import {useEffect, useState} from 'react';
import {translations} from 'presentation/translations-new';
import {UseDateFilterProps} from './types';

const {procedureTypeLabel, procedureStatusLabel} = translations['pt-br'].privateFlow.myReferrals;

export const useTypeFilter = (props: UseDateFilterProps) => {
	const [openDrawerState, setOpenDrawerState] = useState(false);

	const [typeFilterState, setTypeFilterState] = useState<string>(
		props.currentFilters.tipoProcedimento || 'all',
	);

	const [statusFilterState, setStatusFilterState] = useState<string>(
		props.currentFilters.status || 'all',
	);

	const handleSelectType = (value: string) => {
		setTypeFilterState(value);
	};

	const handleSelectStatus = (value: string) => {
		setStatusFilterState(value);
	};
	const listFilters = [
		{
			categoryTitle: procedureTypeLabel,
			categoryItemsList: props.filters.types.map(filter => ({
				active: typeFilterState === filter.category,
				title: filter.label,
				dataTagId: filter.dataTagId,
				onClick: () => handleSelectType(filter.category),
			})),
		},
		{
			categoryTitle: procedureStatusLabel,
			categoryItemsList: props.filters.status.map(filter => ({
				active: statusFilterState === filter.category,
				title: filter.label,
				dataTagId: filter.dataTagId,
				onClick: () => handleSelectStatus(filter.category),
			})),
		},
	];

	const handleClearFilters = () => {
		setTypeFilterState(props.defaultFilters.tipoProcedimento || 'all');
		setStatusFilterState(props.defaultFilters.status || 'all');
		props.handleFilter({
			tipoProcedimento: props.defaultFilters.tipoProcedimento,
			status: props.defaultFilters.status,
		});
		setOpenDrawerState(false);
	};

	const handleSubmitFilters = () => {
		props.handleFilter({
			tipoProcedimento: typeFilterState === 'all' ? undefined : typeFilterState,
			status: statusFilterState === 'all' ? undefined : statusFilterState,
		});
		setOpenDrawerState(false);
	};

	useEffect(() => {
		const newType = props.currentFilters.tipoProcedimento || 'all';
		if (typeFilterState !== newType) {
			setTypeFilterState(newType);
		}

		const newStatus = props.currentFilters.status || 'all';
		if (statusFilterState !== newStatus) {
			setStatusFilterState(newStatus);
		}
	}, [props.currentFilters.tipoProcedimento, props.currentFilters.status]);

	return {
		openDrawerState,
		setOpenDrawerState,
		typeFilterState,
		statusFilterState,
		handleClearFilters,
		listFilters,
		handleSubmitFilters,
	};
};
